angular.module('mainContentArea')
  .directive('mainContentPane', function() {
    return {
      restrict: 'E',
      templateUrl: '/resources/main-content-area/partials/main-content-pane.html',
      controller: [
        '$rootScope',
        '$scope',
        '$state',
        'dblAnalyticsProvider',
        'assignMode',
        'authentication',
        'navigation',
        function(
          $rootScope,
          $scope,
          $state,
          $analytics,
          $assignMode,
          authentication,
          navigation) {

          var customer = authentication.getCustomer();
          $scope.isGuardian = authentication.isGuardian(customer);

          $scope.useBts2020View = authentication.useBts2020Nav();

          var setPreposition = function() {
              var studentLevel = ($state.current.name === 'student');
              $scope.preposition = studentLevel ? 'for' : 'in';
          };

          $scope.getItemClass = function () {
              var itemClass;

              switch($state.current.name) {
                  case 'district':
                      itemClass = 'district-info';
                      break;
                  case 'school':
                      itemClass = 'school-info';
                      break;
                  case 'grade':
                      itemClass = $state.params.schoolId !== undefined ? 'teacher-info' : 'school-info';
                      break;
                  case 'teacher':
                      itemClass = 'teacher-info';
                      break;
                  case 'classroom':
                      itemClass = 'classroom-info';
                      break;
                  case 'student':
                      itemClass = 'student-info';
                      break;
              }

              return itemClass;
          };

          $scope.onClickAssignmentCancel = function () {
              // TODO - use a separate object and restore it
              navigation.tryNavigate().then(function () {
                  $assignMode.onClickAssignMode();
                  $analytics.eventTrack('Assignment Discarded', {
                      category: 'Assign Focus',
                      label: $scope.item.type
                  });
              }, function() {
                  $analytics.eventTrack('Assignment Exit Canceled', {
                      category: 'Assign Focus',
                      label: $scope.item.type
                  });
              });
          };

          $scope.onCreateAssignmentButtonClick = function() {
              $rootScope.$broadcast('createAssignmentTriggered');
          };

          $scope.assignModeService = $assignMode;

          $scope.$watch('assignModeService.isAssignMode', function(assign) {
              if (assign) {
                  setPreposition();
              }
          });

      }]
    };
  });
